<template>
	<form>
		<!-- ROW TWO -->
		<div class="vx-row">
			<div class="vx-col md:w-1/1 w-full">
				<!--ADDRESS -->
				<vs-input
					class="w-full"
					:label="$t('Address')"
					v-model="formData.address"
					v-validate="'required'"
					name="address"
					id="address"
				/>
				<span class="text-danger text-sm" v-show="errors.has('address')">{{
					$t("GroupValidMessages.ItemAddress")
				}}</span>
			</div>
		</div>

		<!-- ROW THREE -->
		<div class="vx-row">
			<!-- COUNTRY -->
			<div class="vx-col md:w-1/1 w-full">
				<div class="mt-1">
					<label class="vs-input--label">{{ $t("Country") }}</label>
					<v-select
						v-model="selectedCountry"
						name="country"
						v-validate="'required'"
						:clearable="false"
						:options="countriesOptions"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						:disabled="
							formData.address === '' || formData.address === null || formData.address === undefined
						"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('country')">{{
						$t("VisitPointObject.Create.ValidMessages.Country")
					}}</span>
				</div>
			</div>
			<div class="vx-col md:w-1/1 w-full">
				<!--Department -->
				<div class="mt-1">
					<label class="vs-input--label">{{ getPoliticalDivision.department }}</label>
					<v-select
						v-model="selectedDepartment"
						name="departments"
						v-validate="'required'"
						:clearable="false"
						:options="departments"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						:loading="departments.length <= 0 && selectedCountry.value != '' ? true : false"
						:disabled="
							departments.length <= 0 ||
							formData.address === '' ||
							formData.address === null ||
							formData.address === undefined
						"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('departments')">{{
						$t("ValidateField", {n: getPoliticalDivision.department.toLowerCase()})
					}}</span>
				</div>
			</div>
			<div class="vx-col md:w-1/1 w-full">
				<!--CITY -->
				<div class="mt-1 mb-1">
					<label class="vs-input--label">{{ getPoliticalDivision.city }}</label>
					<v-select
						v-model="selectedCity"
						name="cities"
						v-validate="'required'"
						:clearable="false"
						:options="cities"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						:loading="
							cities.length <= 0 && selectedDepartment && selectedCountry.value != '' ? true : false
						"
						:disabled="
							cities.length <= 0 ||
							formData.address === '' ||
							formData.address === null ||
							formData.address === undefined
						"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('cities')">{{
						$t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()})
					}}</span>
				</div>
			</div>
		</div>

		<div class="vx-row" style="display: none">
			<div class="vx-col md:w-1/2 w-full">
				<vs-input
					class="w-full mb-2"
					:label="$t('MapModule.Latitude')"
					v-model="formData.cy"
					name="cy"
					ref="cy"
					id="cy"
				/>
				<span class="text-danger text-sm" v-show="errors.has('cy')">{{ errors.first("cy") }}</span>
			</div>
			<div class="vx-col md:w-1/2 w-full">
				<vs-input
					class="w-full mb-2"
					:label="$t('MapModule.Longitude')"
					v-model="formData.cx"
					name="cx"
					ref="cx"
					id="cx"
				/>
				<span class="text-danger text-sm" v-show="errors.has('cx')">{{ errors.first("cx") }}</span>
			</div>
		</div>

		<div class="vx-row">
			<div class="vx-col md:w-2/2 w-full">
				<vs-input
					class="w-full mb-2"
					v-model="coords"
					:label="$t('MapModule.Coordinates')"
					name="coords"
					ref="coords"
					id="coords"
					:disabled="!enableCoords"
				/>
			</div>
		</div>
		<vs-prompt
			title=""
			:active.sync="activePrompt"
			@cancel="cancelPrompt"
			@accept="acceptAlert"
			@close="cancelPrompt"
		>
			<div class="con-exemple-prompt">
				<p>
					{{ $t("Zonification.FormGeo.FindCoords") }}
				</p>
				<vs-input
					placeholder="Code"
					vs-placeholder="Code"
					v-model="dataGeo.address1"
					class="mt-3 w-full mb-4"
				/>
				<p>{{ $t("Zonification.FormGeo.AskUseDirection") }}</p>
			</div>
		</vs-prompt>
	</form>
</template>
<script>
import vSelect from "vue-select";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import visitPointImg from "@/assets/images/markers/visit_point.png";
import {addInfoBubble, addMarkerHereMap, centerHereMap, clearMap} from "../../utils/HereMap";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import {politicalDivisionMixin} from "@/mixins/politicalDivisionMixin.js";

export default {
	mixins: [politicalDivisionMixin],
	components: {
		vSelect,
	},
	props: {
		data: {
			type: Object,
			default: () => {
				return {
					address: "",
					cx: "",
					cy: "",
					country: "",
					department: "",
					city: "",
				};
			},
		},
		autoGeo: {
			type: Boolean,
			default: true,
		},
		autoAddMarker: {
			type: Boolean,
			default: true,
		},
		getDataGeo: {
			type: Boolean,
			default: false,
		},
		setDataGeo: {
			type: Function,
		},
		showDataGeoAlert: {
			type: Function,
		},
	},
	data() {
		return {
			formData: {...this.data},
			departments: [],
			countries: [],
			cities: [],
			selectedCity: null,
			selectedDepartment: null,
			dataGeo: {
				dirtrad: "",
				estado: "",
				latitude: "",
				longitude: "",
			},
			coords: "",
			activePrompt: false,
			enableCoords: false,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			activeGeocoder: true,
		};
	},
	watch: {
		selectedCity(object) {
			if (Object.entries(object).length > 0) {
				this.formData.city = typeof object === "object" ? object.label : object;
				this.activeGeocoder ? this.geoCoder() : (this.activeGeocoder = true);
			}
		},
		selectedDepartment(object) {
			if (object) {
				this.formData.department = typeof object === "object" ? object.label : object;
				this.getCities(object.value);
			}
		},
		enableCoords(val) {
			if (val) {
				this.$emit("showGeoAgain", val);
			}
		},
		"dataGeo.address"(val) {
			if (val) {
				this.$emit("showGeoAgain", false);
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries_sitidata.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountriesByTokenSitiData")
				.then((res) => {
					if (res.data.length === 1) {
						this.selectedCountry = {
							label: res.data[0]["country_name"].toUpperCase(),
							value: res.data[0]["country_name"].toUpperCase(),
						};
					}
				})
				.catch((error) => {
					throw new Error(error);
				});
		}
	},
	computed: {
		countriesOptions() {
			return this.generateOptionSelect(
				this.$store.state.moduleCommon.countries_sitidata,
				"country_name",
				"country_name"
			);
		},
		selectedCountry: {
			get() {
				return {
					label: this.formData.country === undefined ? "" : this.formData.country,
					value: this.formData.country === undefined ? "" : this.formData.country,
				};
			},
			set(obj) {
				this.selectedDepartment = {};
				this.selectedCity = {};
				this.formData.country = obj.label;
				this.getDepartments(obj.label);
			},
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		getCities(departmentName) {
			this.$store
				.dispatch("moduleCommon/getCitiesByDeparment", {
					name: departmentName,
					country: this.formData.country,
				})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		getDepartments(countryName) {
			this.$store
				.dispatch("moduleCommon/getDepartments", {name: countryName})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		generateInfowindowContent(infoWindowData) {
			// Diseño del contenido html del infowindows
			return (
				'<div id="infoWindow" class="gm-style-iw gm-style-iw-c" style="padding-right: 0px; padding-bottom: 0px; max-width: 648px; max-height: 199px; min-width: 0px;">' +
				'<h5 class="mb-1 font-bold">' +
				`${infoWindowData}` +
				"</h5>"
			);
			("</div>");
		},
		addMarkerGeo(lat, lng) {
			// Opciones
			let options = {
				drag: true,
				icon: visitPointImg,
				title: this.$t("Zonification.CurrentPosition"),
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: this.generateInfowindowContent(this.$t("Zonification.DragToRelocate")),
				},
				onDragend: (e, coords) => {
					this.geoInverso({country: this.formData.country, cy: coords.lat, cx: coords.lng});
					if (!this.$store.state.moduleMap.toggleGeorreferencer) {
						this.$store.commit("moduleMap/TOGGLE_GEO", true);
						this.acceptAlert();
					}
				},
			};
			let marker = addMarkerHereMap(lat, lng, options, true);
			addInfoBubble(marker, options.infoWindow.content);
			centerHereMap(lat, lng, {zoom: 18});
		},
		geoInverso({country, cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {country, cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					if (this.formData.address !== this.dataGeo.address1) {
						this.activePrompt = true;
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPointObject.Create.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPointObject.Create.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
					this.coords = `${cy},${cx}`;
					this.formData.cy = parseFloat(cy).toFixed(8);
					this.formData.cx = parseFloat(cx).toFixed(8);
					this.enableCoords = true;
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		geoCoder() {
			this.activeGeocoder = true;
			const {country, city, address, department} = this.formData;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPointObject.Create.MissingAddress.Title"),
					text: this.$t("VisitPointObject.Create.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}

					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("MapModule.Georeferencer"),
							text: this.$t("ManualData.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200 && res.message === "Geocodificacion Exitosa.") {
						this.autoAddMarker && clearMap();
						this.dataGeo = {...res.data};
						this.formData.cy = parseFloat(this.dataGeo.latitude).toFixed(8);
						this.formData.cx = parseFloat(this.dataGeo.longitude).toFixed(8);
						this.autoAddMarker && this.addMarkerGeo(this.formData.cy, this.formData.cx);
						this.getDataGeo && this.setDataGeo(this.formData);
						this.coords = `${this.formData.cy},${this.formData.cx}`;
						this.enableCoords = true;
						this.getDataGeo &&
							this.showDataGeoAlert(this.$t("VisitPointObject.Create.FindAddress.Text"), "success");
						this.$emit("minimizeGeoActiveEmit");
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		openConfirmDirection(res) {
			this.$vs.dialog({
				type: "confirm",
				color: "success",
				title: "",
				text: this.$t("Zonification.FormGeo.FindDirection") + ` ${res.data.address1}`,
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlert() {
			this.selectedCountry.label = this.dataGeo.country_long_name;
			this.formData.country = this.dataGeo.country_long_name;
			this.formData.address = this.dataGeo.address1;
			this.selectedDepartment = this.dataGeo.department1;
			this.selectedCity = {label: this.dataGeo.city1, value: this.dataGeo.city1};
			this.formData.department = this.dataGeo.department1;
			this.formData.city = this.dataGeo.city1;
			this.coords = `${this.formData.cy}, ${this.formData.cx}`;
			(this.activeGeocoder = false), this.$emit("maximizeGeoActiveEmit");
		},
		cancelPrompt() {
			this.dataGeo.address1 = "";
			this.geoCoder();
		},
		copyResults() {
			let $cy = document.querySelector("#coords");
			$cy.select();
			try {
				$cy.select();
				$cy.setSelectionRange(0, 99999);
				document.execCommand("copy");
			} catch (err) {
				alert("Oops, unable to copy");
			}
			setTimeout(() => {
				this.enableCoords = false;
			}, 2000);
		},
	},
};
</script>
